// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import OptionTable02 from '../components/OptionTable02';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap03(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <div className="content_text">
                <em>De novo</em> assembly refers to the process of using short overlapping reads to obstain
                a genome sequence for a species without a reference sequence. The assembly process yields
                two different sequences: contigs and scaffolds.
            </div>
            <h2 className="content_title2">Genome assembly</h2>
            <div className="content_text">
                GAAP employs four assembly tools, SOAPdenovo2, ALLPATHS-LG, Abyss 2.0, and Velvet, which are widely used. User can adopt one of these tools by
                considering the assembly quality, memory requirement, and execution time.
            </div><br/>
            <div className="content_command_title">SOAPdenovo</div><br/>
            <div className="content_text">
                SOAPdenovo can perform assembly even for large mammalian genomes 
                while using relatively small memory. In addition, its successor, 
                SOAPdenovo2 (referred to here as SOAPdenovo), includes improvements 
                and new features, including the new contig and scaffold construction 
                improvements.
            </div>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://github.com/aquaskyline/SOAPdenovo2" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">Configuration File</li>
            <div className="content_text">
                Before running the SOAPdenonvo command, 
                it is first necessary to generate a configuration file.
            </div>
            <OptionTable02 data={{
                options:[
                        ['[LIB]', 'max_rd_len=101','avg_ins=170','reverse_seq=0','asm_flags=3','rank=1','q1=DNAread170_1.fastq','q2=DNAread170_2.fastq'],
                        ['[LIB]', 'max_rd_len=101','avg_ins=2900','reverse_seq=1','asm_flags=2','rank=2','q1=DNAread2900_1.fastq','q2=DNAread2900_2.fastq']
                    ],
                descs:[
                    {   
                        op:'-max_rd_len',
                        desc:'maximum read length'
                    },
                    {
                        op:'-avg_ins',
                        desc: 'specify the mean insert size of the reads',
                    },
                    { 
                        op:'-reverse_seq',
                        desc:`specify how the read sequences need to be complementary reversed. 
                            0 (forward-reverse)  or 1 (reverse-forward)`
                    },
                    {
                        op:'-asm_flags',
                        desc:`indicate which parts of the assembly process use the read file. 1 (for contig assembly only), 
                        2 (for scaffold assembly only), 
                        3 (for both contig and scaffold assembly), or 4 (for gap closure only)`
                    },
                    {
                        op:'-rank',
                        desc: 'order in which read files are used for scaffold assembly'
                    },
                    {
                        op:'-q1, q2',
                        desc: 'indicate the read files with FASTQ formats'
                    }
                ]
            }}
            /><br/>
            <li className="content_description">SOAPdenovo Command</li>
            <CommandBox lines={[
                {data:'soapdenovo all -s config.file -K kmerlength -o outprefix'},
            ]}
            /><br/>
            <li className="content_description">Options for SOApdenovo</li>
            <OptionTable
                data={[
                    {   option:'-s',
                        desc:'specify the configuration file'},
                    {   option:'-K',
                        desc:'specify the k-mer length'},
                    {   option:'-o',
                        desc:'specify the prefix of the output file'},
                ]}
            /><br />
            <li className="content_description">Output of SOAPdenovo</li>
            <div className="content_text">
                outprefix.contig: stores the contigs.<br/>
                outprefix.scafSeq: stores the scaffolds generated by de novo assembly.
            </div>
            <div className="content_buttons_div">
                <Link to="/Gaap02"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap03_AllPath"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap03;